import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="py-20 text-center">
      <h1 className="text-2xl font-semibold">Not found</h1>
      <p className="mt-2 text-sm text-muted">That page doesn't exist.</p>
      <Link to="/" className="mt-4 inline-block text-sm text-accent">Back to markets</Link>
    </div>
  );
}
